<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.45 54.65">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_3" data-name="Layer 3">
                <g>
                    <ellipse cx="27.73" cy="27.33" rx="27.73" ry="27.33" :fill="color" />
                    <path
                        d="M46.61,27.14l0-.12a6.92,6.92,0,0,0-.17-1.19c0-.15-.07-.3-.1-.46a17.1,17.1,0,0,0-1-3.52,19.22,19.22,0,0,0-2.08-3.78,19.5,19.5,0,0,0-2.54-2.9c-.31-.3-.64-.58-1-.85a19.47,19.47,0,0,0-3.28-2.15,17.09,17.09,0,0,0-4.08-1.52c-.85-.18-1.72-.33-2.59-.45-.26,0-.59-.06-.9-.09l-.13,0V5.67c0-.08,0-.16,0-.39l-.13-1.57L13.77,14.05,28.67,24.5V18.07h.12a9.94,9.94,0,0,1,3.14.77,10.71,10.71,0,0,1,3,1.85,11,11,0,0,1,3.7,6.74,10.33,10.33,0,0,1,0,3.09c0,.2-.3,1.48-.32,1.58A11,11,0,0,1,28.84,40a11,11,0,0,1-8.64-2.89,11,11,0,0,1-2.76-4,9.66,9.66,0,0,1-.61-2.29l-.28-2.64H8.81l0,.88a18.91,18.91,0,0,0,31.69,14,18.67,18.67,0,0,0,6-10.92A20.49,20.49,0,0,0,46.61,27.14Z"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { FORECAST_WINDOW_COLORS } from "@/components/forecasts/utils/utilis";

export default {
    data() {
        return {
            color: FORECAST_WINDOW_COLORS.RE_CHALLENGED
        };
    }
};
</script>



// WEBPACK FOOTER //
// ReChallengeIcon.vue?6446e4a2